import {
  OPEN_PLATFORM_MY_APP_PAGE_REQUEST,
  OPEN_PLATFORM_MY_APP_LIST_REQUEST,
  OPEN_PLATFORM_MY_APP_ON_CLICK_REMOVE_APP,
  OPEN_PLATFORM_MY_APP_ON_CONFIRM_REMOVE_APP,
  OPEN_PLATFORM_MY_APP_ON_CANCEL_REMOVE_APP,
  OPEN_PLATFORM_MY_APP_SET_APPS,
  OPEN_PLATFORM_MY_APP_SET_REMOVED_APP,
  OPEN_PLATFORM_MY_APP_HIDE_CONFIRM_REMOVE_MODAL,
  OPEN_PLATFORM_MY_APP_SHOW_CONFIRM_REMOVE_MODAL,
  OPEN_PLATFORM_MY_APP_SET_SUBMIT,
  OPEN_PLATFORM_MY_APP_SET_BUSINESS,
} from './constants';

export function setSubmit({ submit }) {
  return { type: OPEN_PLATFORM_MY_APP_SET_SUBMIT, payload: { submit } };
}

export function pageRequest({ userId }) {
  return { type: OPEN_PLATFORM_MY_APP_PAGE_REQUEST, payload: { userId } };
}

export function listRequest({ userId }) {
  return { type: OPEN_PLATFORM_MY_APP_LIST_REQUEST, payload: { userId } };
}

export function setApps({ apps }) {
  return { type: OPEN_PLATFORM_MY_APP_SET_APPS, payload: { apps } };
}

export function setRemovedApp({ app }) {
  return { type: OPEN_PLATFORM_MY_APP_SET_REMOVED_APP, payload: { app } };
}

export function onClickRemoveApp({ app }) {
  return { type: OPEN_PLATFORM_MY_APP_ON_CLICK_REMOVE_APP, payload: { app } };
}

export function onConfirmRemoveApp({ app, previousApps, userId }) {
  return {
    type: OPEN_PLATFORM_MY_APP_ON_CONFIRM_REMOVE_APP,
    payload: { app, previousApps, userId },
  };
}

export function onCancelRemoveApp() {
  return { type: OPEN_PLATFORM_MY_APP_ON_CANCEL_REMOVE_APP, payload: {} };
}

export function showRemoveAppModal() {
  return { type: OPEN_PLATFORM_MY_APP_SHOW_CONFIRM_REMOVE_MODAL, payload: {} };
}

export function hideRemoveAppModal() {
  return { type: OPEN_PLATFORM_MY_APP_HIDE_CONFIRM_REMOVE_MODAL, payload: {} };
}

export function setBusiness({ business }) {
  return { type: OPEN_PLATFORM_MY_APP_SET_BUSINESS, payload: { business } };
}
